export default ({ app, router, store, Vue }) => {
  if (localStorage.getItem('store')) {
    store.replaceState(Object.assign({}, store.state, JSON.parse(localStorage.getItem('store'))))
  }
}
